/**
 * Spec §7 — Launch Game:
 *   1. Open Game Board in a tab named `gameboard-<gameId>` (subsequent
 *      Launch clicks focus the existing tab rather than spawning a dupe).
 *   2. Navigate the current tab to /control-room.
 *
 * The lifecycle status transitions to in-progress server-side when the
 * game state advances from pregame → lobby (see
 * functions/src/gameStateChanged.js); this helper does not write
 * publishStatus.
 */
export const launchGame = (gameId, navigate) => {
  if (!gameId) return;
  const boardUrl = `/gameboard/${gameId}`;
  const tabName = `gameboard-${gameId}`;
  window.open(boardUrl, tabName);
  navigate(`/manage/game/${gameId}/control-room`);
};

/** Just open the Board (no navigation of current tab). */
export const openBoardInNewTab = (gameId) => {
  if (!gameId) return;
  window.open(`/gameboard/${gameId}`, `gameboard-${gameId}`);
};
